/**
 * Per-destination gallery of 6 curated Unsplash photos.
 * Slot layout (matches CSS mosaic):
 *   0 → wide landscape  (900×520)  — row 1 left (spans 2 cols)
 *   1 → portrait/square (500×520)  — row 1 right
 *   2 → activity shot   (500×400)  — row 2 left
 *   3 → detail / food   (500×400)  — row 2 center
 *   4 → neighborhood    (500×400)  — row 2 right
 *   5 → panoramic       (1200×480) — row 3 full-width
 */
const DESTINATION_GALLERIES = {

    /* ── BEACH ───────────────────────────────────────────── */
    'maldives-beach': [
        'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583623025817-d180a2221d0a?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=1200&h=480&fit=crop&q=80',
    ],
    'bali-beach': [
        'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1604999333679-b86d54738315?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520454974749-a8b338df2b04?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1573790387438-4da905039392?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=480&fit=crop&q=80',
    ],
    'santorini-beach': [
        'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555993539-1732b0258235?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=1200&h=480&fit=crop&q=80',
    ],
    'tulum-beach': [
        'https://images.unsplash.com/photo-1504730030853-eff311f57d3c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1552074284-5e88ef1aef18?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510822836049-f2b59aff7f13?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=1200&h=480&fit=crop&q=80',
    ],
    'amalfi-coast-beach': [
        'https://images.unsplash.com/photo-1533587851505-d119e13fa0d7?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1612838320302-4b3b3996e2b4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1543429776-2782fc8e10dd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&h=480&fit=crop&q=80',
    ],
    'phuket-beach': [
        'https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&h=480&fit=crop&q=80',
    ],
    'cancun-beach': [
        'https://images.unsplash.com/photo-1552074284-5e88ef1aef18?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504730030853-eff311f57d3c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510822836049-f2b59aff7f13?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&h=480&fit=crop&q=80',
    ],
    'zanzibar-beach': [
        'https://images.unsplash.com/photo-1586861635167-e5223aadc9fe?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544984243-ec57ea16fe25?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=1200&h=480&fit=crop&q=80',
    ],
    'hawaii-beach': [
        'https://images.unsplash.com/photo-1507876466758-bc54f384809c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483168527879-c66136b56105?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473496169904-658ba7574b0d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542897644-e4af679c08e9?w=1200&h=480&fit=crop&q=80',
    ],
    'mykonos-beach': [
        'https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555993539-1732b0258235?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── CULTURE ─────────────────────────────────────────── */
    'kyoto-culture': [
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=1200&h=480&fit=crop&q=80',
    ],
    'rome-culture': [
        'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541370976299-4d24be33b57f?w=1200&h=480&fit=crop&q=80',
    ],
    'athens-culture': [
        'https://images.unsplash.com/photo-1555993539-1732b0258235?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1603565816030-6b389eeb23cb?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=1200&h=480&fit=crop&q=80',
    ],
    'istanbul-culture': [
        'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1527838832700-5059252407fa?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1565793979268-6e5f4e8b4a72?w=1200&h=480&fit=crop&q=80',
    ],
    'marrakech-culture': [
        'https://images.unsplash.com/photo-1597212618440-806262de4f6b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1553913861-c0fddf2619ee?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544984243-ec57ea16fe25?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1489493887464-892be6d1daae?w=1200&h=480&fit=crop&q=80',
    ],
    'prague-culture': [
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473951574080-01fe45ec8643?w=1200&h=480&fit=crop&q=80',
    ],
    'vienna-culture': [
        'https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1569230919100-d3fd5e1132f4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541732648377-ceb6e2a02505?w=1200&h=480&fit=crop&q=80',
    ],
    'havana-culture': [
        'https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1508532566027-b2032cd8a715?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510510306880-c86cd6f34ee3?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&h=480&fit=crop&q=80',
    ],
    'florence-culture': [
        'https://images.unsplash.com/photo-1543429776-2782fc8e10dd?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541370976299-4d24be33b57f?w=1200&h=480&fit=crop&q=80',
    ],
    'lisbon-culture': [
        'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526735548826-ddd3f3c27800?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1509233725247-49e657c54213?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548707309-dcebeab9ea9b?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── ADVENTURE ───────────────────────────────────────── */
    'iceland-adventure': [
        'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1535139262971-ab8a4fde6c89?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520176902-be0e57a60e92?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=1200&h=480&fit=crop&q=80',
    ],
    'new-zealand-adventure': [
        'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528184039930-bd03972bd974?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&h=480&fit=crop&q=80',
    ],
    'patagonia-adventure': [
        'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1521336575822-6da63fb45455?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=480&fit=crop&q=80',
    ],
    'nepal-adventure': [
        'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&h=480&fit=crop&q=80',
    ],
    'costa-rica-adventure': [
        'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520520731457-9283dd14aa66?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1455156218388-5e61b526818b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&h=480&fit=crop&q=80',
    ],
    'norwegian-fjords-adventure': [
        'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520176902-be0e57a60e92?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=480&fit=crop&q=80',
    ],
    'borneo-adventure': [
        'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520520731457-9283dd14aa66?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1455156218388-5e61b526818b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1536599018102-9f803c140fc1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1511497584788-876760111969?w=1200&h=480&fit=crop&q=80',
    ],
    'swiss-alps-adventure': [
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520176902-be0e57a60e92?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── FOOD ────────────────────────────────────────────── */
    'bangkok-food': [
        'https://images.unsplash.com/photo-1508009603885-50cf7c8dd0c1?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528181304800-259b08848526?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?w=1200&h=480&fit=crop&q=80',
    ],
    'tokyo-food': [
        'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=1200&h=480&fit=crop&q=80',
    ],
    'barcelona-food': [
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555992336-03a23c7b20ee?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510693206972-df098062cb71?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464790719320-516ecd75af6c?w=1200&h=480&fit=crop&q=80',
    ],
    'bologna-food': [
        'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519996529931-28324d5a630e?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=1200&h=480&fit=crop&q=80',
    ],
    'mexico-city-food': [
        'https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504730030853-eff311f57d3c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464219179558-ce56c79c9a58?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510822836049-f2b59aff7f13?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&h=480&fit=crop&q=80',
    ],
    'naples-food': [
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533587851505-d119e13fa0d7?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541370976299-4d24be33b57f?w=1200&h=480&fit=crop&q=80',
    ],
    'copenhagen-food': [
        'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558618047-f4e90d5f3ace?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&h=480&fit=crop&q=80',
    ],
    'lyon-food': [
        'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1565799888715-e82e39a09de4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── BUDGET ──────────────────────────────────────────── */
    'tbilisi-budget': [
        'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544984243-ec57ea16fe25?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1565793979268-6e5f4e8b4a72?w=1200&h=480&fit=crop&q=80',
    ],
    'budapest-budget': [
        'https://images.unsplash.com/photo-1549221987-25a490f65d34?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473951574080-01fe45ec8643?w=1200&h=480&fit=crop&q=80',
    ],
    'bucharest-budget': [
        'https://images.unsplash.com/photo-1555217851-6141535bd771?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&h=480&fit=crop&q=80',
    ],
    'ho-chi-minh-city-budget': [
        'https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528181304800-259b08848526?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?w=1200&h=480&fit=crop&q=80',
    ],
    'sofia-budget': [
        'https://images.unsplash.com/photo-1555217851-6141535bd771?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473951574080-01fe45ec8643?w=1200&h=480&fit=crop&q=80',
    ],
    'krakow-budget': [
        'https://images.unsplash.com/photo-1562883676-8c7feb83f09b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473951574080-01fe45ec8643?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── LUXURY ──────────────────────────────────────────── */
    'dubai-luxury': [
        'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526495124232-a04e1849168c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=1200&h=480&fit=crop&q=80',
    ],
    'monaco-luxury': [
        'https://images.unsplash.com/photo-1558618047-f4e90d5f3ace?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533587851505-d119e13fa0d7?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1612838320302-4b3b3996e2b4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&h=480&fit=crop&q=80',
    ],
    'singapore-luxury': [
        'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1508009603885-50cf7c8dd0c1?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1540621329798-4a9cc5d6c3c7?w=1200&h=480&fit=crop&q=80',
    ],
    'st-barts-luxury': [
        'https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548013146-72479768bada?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=1200&h=480&fit=crop&q=80',
    ],
    'bora-bora-luxury': [
        'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&h=480&fit=crop&q=80',
    ],
    'aspen-luxury': [
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520176902-be0e57a60e92?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1521336575822-6da63fb45455?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=1200&h=480&fit=crop&q=80',
    ],
    'zurich-luxury': [
        'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── CITY BREAKS ─────────────────────────────────────── */
    'new-york-city-break': [
        'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1568515387631-8b650bbcdb90?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1522083165195-3424ed129620?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1546436836-07a91091f160?w=1200&h=480&fit=crop&q=80',
    ],
    'london-city-break': [
        'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1529655683826-aba9b3e77383?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520986606214-8b456906c813?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526476374955-32a3a1d57d12?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1200&h=480&fit=crop&q=80',
    ],
    'berlin-city-break': [
        'https://images.unsplash.com/photo-1467269204165-bdbdd2b7cc93?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&h=480&fit=crop&q=80',
    ],
    'amsterdam-city-break': [
        'https://images.unsplash.com/photo-1534180477871-5d6cc81f3920?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576924542622-772281b13739?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558618047-f4e90d5f3ace?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559561853-08451507cbe7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526735548826-ddd3f3c27800?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?w=1200&h=480&fit=crop&q=80',
    ],
    'seoul-city-break': [
        'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1540621329798-4a9cc5d6c3c7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── ROMANCE ─────────────────────────────────────────── */
    'paris-romance': [
        'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1565799888715-e82e39a09de4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526676037777-05a232554f77?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=1200&h=480&fit=crop&q=80',
    ],
    'venice-romance': [
        'https://images.unsplash.com/photo-1514890547357-a9ee288728e0?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541370976299-4d24be33b57f?w=1200&h=480&fit=crop&q=80',
    ],
    'provence-romance': [
        'https://images.unsplash.com/photo-1499346030926-9a72daac6c63?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526676037777-05a232554f77?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1565799888715-e82e39a09de4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=1200&h=480&fit=crop&q=80',
    ],
};

export default DESTINATION_GALLERIES;
